(function () {
  var raiz = document.querySelector('[data-sl-producto]'), datosEl = document.getElementById('sl-datos');
  if (!raiz || !datosEl) return;
  var D = JSON.parse(datosEl.textContent), CFG = window.SLCFG || {}, V = D.variantes;
  if (!V.length) return;
  var q = function (s) { return raiz.querySelector(s); };
  var fin = CFG.fin ? Date.parse(CFG.fin) : NaN;
  var TMAX = CFG.tarjetaMax || 3;
  var PACKS = (CFG.packs && CFG.packs.length) ? CFG.packs : [1, 2, 3];
  var estado = { kits: 1, estilos: [0, 0, 0] };
  var primera = V.findIndex(function (v) { return v.disponible; });
  if (primera > 0) estado.estilos = [primera, primera, primera];

  var MON = (window.Shopify && window.Shopify.currency) || {}, ISO = MON.active || 'MXN';
  function mxn(c) {
    if (ISO === 'MXN') { var dec = c % 100 ? 2 : 0; return '$' + (c / 100).toLocaleString('en-US', { minimumFractionDigits: dec, maximumFractionDigits: dec }); }
    return new Intl.NumberFormat('es', { style: 'currency', currency: ISO }).format(c / 100);
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function ofertaActiva() { return isNaN(fin) || fin > Date.now(); }
  function descuento(k) {
    if (!ofertaActiva() || !CFG.desc || !CFG.desc[k]) return 0;
    if (ISO === 'MXN') return CFG.desc[k];
    return Math.round(suma(k, 'precio') * CFG.desc[k] / ((CFG.base || 79900) * k));
  }
  function es3x2() { return CFG.desc && CFG.tresx2 === true && descuento(3) > 0; }
  function elegidas() { return estado.estilos.slice(0, estado.kits).map(function (i) { return V[i]; }); }
  function suma(k, campo) { var t = 0; for (var i = 0; i < k; i++) t += V[estado.estilos[i]][campo] || V[estado.estilos[i]].precio; return t; }
  function total(k) { return suma(k, 'precio') - descuento(k); }
  function regular(k) { return suma(k, 'regular'); }

  function pintar() {
    var packs = PACKS.map(function (k) {
      var t = total(k), r = regular(k), ahorro = r - t, sel = estado.kits === k, filas = '';
      if (sel && D.tieneEstilos) {
        filas = '<div class="sl-estilos">';
        for (var i = 0; i < k; i++) {
          filas += '<div class="sl-fila"><span class="sl-fila-k">Kit ' + (i + 1) + '</span>' + V.map(function (v, j) {
            return '<button type="button" class="sl-pill" data-kit="' + i + '" data-est="' + j + '" aria-pressed="' + (estado.estilos[i] === j) + '"' + (v.disponible ? '' : ' disabled') + '>' + v.titulo + '</button>';
          }).join('') + '</div>';
        }
        filas += '</div>';
      }
      var tag = '';
      if (k === 2 && descuento(2) > 0) tag = '<span class="sl-tag">2.º kit a mitad de precio</span>';
      if (k === 3 && es3x2()) tag = '<span class="sl-tag">Lleva 3, paga 2</span>';
      var nombre = (k === 3 && es3x2()) ? '2 + 1 GRATIS' : k + ' kit' + (k > 1 ? 's' : '');
      return '<div class="sl-pack' + (sel ? ' sl-sel' : '') + (k === 3 && es3x2() ? ' sl-pack-3x2' : '') + '"><label><input type="radio" name="sl-pack" value="' + k + '"' + (sel ? ' checked' : '') + '>' +
        '<span><span class="sl-pack-n">' + nombre + '</span>' + tag +
        (k > 1 ? '<span class="sl-pack-u">' + mxn(Math.round(t / k)) + ' c/u</span>' : '') + (ahorro > 0 ? '<span class="sl-ahorro">Ahorras ' + mxn(ahorro) + '</span>' : '') + '</span>' +
        '<span class="sl-pack-t">' + (ahorro > 0 ? '<s>' + mxn(r) + '</s>' : '') + mxn(t) + '</span></label>' + filas + '</div>';
    }).join('');
    q('[data-sl-packs]').innerHTML = packs;

    var conTarjeta = CFG.tarjeta > 0 && ofertaActiva() && CFG.tarjetasQuedan !== '0';
    var tarjetaAplica = estado.kits > 1 && estado.kits <= TMAX;
    var filaExtra = '';
    if (estado.kits === 3 && es3x2()) {
      filaExtra = '<div class="sl-regalo"><span>1 kit de regalo (2 + 1 gratis)</span><span>Incluido</span></div>';
    } else if (conTarjeta) {
      filaExtra = '<div class="sl-regalo' + (tarjetaAplica ? '' : ' sl-off') + '"><span>Tarjeta de regalo de $' + CFG.tarjeta + ' MXN</span><span>' + (tarjetaAplica ? 'Incluida' : (TMAX === 2 ? 'Con 2 kits' : 'Con 2 o 3 kits')) + '</span></div>';
    }
    q('[data-sl-regalos]').innerHTML = '<div class="sl-label">Regalos incluidos</div>' +
      '<div class="sl-regalo"><span>Envío gratis a todo México</span><span>Incluido</span></div>' +
      '<div class="sl-regalo"><span>Garantía de 100 días</span><span>Incluida</span></div>' + filaExtra;

    var disp = elegidas().every(function (v) { return v.disponible; }), cta = q('[data-sl-cta]');
    cta.disabled = !disp;
    cta.textContent = disp ? 'Agregar al carrito · ' + mxn(total(estado.kits)) : 'Agotado';
    q('[data-sl-sticky-txt]').textContent = 'Kit SeraLash · ' + mxn(total(estado.kits));

    var v1 = V[estado.estilos[0]], sufijo = ISO === 'MXN' ? ' MXN' : '', enOferta = v1.regular > v1.precio;
    q('.sl-precio').innerHTML = mxn(v1.precio) + sufijo + (enOferta ? ' <s>' + mxn(v1.regular) + '</s><span class="sl-lanz">Precio de lanzamiento</span>' : '') + '<small>IVA incluido · Envío gratis</small>';
    var fp = document.querySelector('.sl-final p');
    if (fp) fp.textContent = '1 kit por ' + mxn(v1.precio) + sufijo + (enOferta ? ' en lanzamiento (precio regular ' + mxn(v1.regular) + ')' : '') + (es3x2() ? ', o 3 kits por ' + mxn(total(3)) + ' con el 2 + 1 gratis' : '') + '. Envío gratis y garantía de 100 días.';

    vigencia();
    urgencia();
    cajaOferta();
  }

  /* Caja «2 + 1 GRATIS» bajo el botón. Textos editables en el editor de temas (SeraLash · Compra → Caja 2 + 1). */
  function cajaOferta() {
    var c = q('[data-sl-of-caja]'); if (!c) return;
    var C = D.caja || {};
    if (C.mostrar === false || !es3x2() || !ofertaActiva()) { c.hidden = true; return; }
    var p = V[estado.estilos[0]].precio, sep = p * 3, t = sep - descuento(3);
    c.hidden = false;
    var ms = isNaN(fin) ? Infinity : fin - Date.now(), dias = Math.ceil(ms / 864e5), tag = C.etiqueta || '';
    if (ms <= 864e5) tag = '● ÚLTIMO DÍA';
    else if (dias <= 3) tag = '● ÚLTIMOS ' + dias + ' DÍAS';
    else if (isFinite(ms)) tag = 'TERMINA EL ' + new Date(fin).toLocaleString('es-MX', { timeZone: 'America/Mexico_City', day: 'numeric', month: 'long' }).toUpperCase();
    var texto = esc(C.texto || '').replace('[precio]', '<b>' + mxn(t) + '</b>');
    c.innerHTML = (tag ? '<span class="sl-of-tag">' + esc(tag) + '</span>' : '') +
      (C.titulo ? '<b class="sl-of-tit">' + esc(C.titulo) + '</b>' : '') +
      (texto ? '<p class="sl-of-txt">' + texto + '</p>' : '') +
      (C.separado ? '<div class="sl-of-sep">' + esc(C.separado) + ' <span aria-hidden="true">→</span> <b>' + mxn(sep) + '</b></div>' : '') +
      (C.boton ? '<button type="button" class="sl-of-btn" data-sl-3x2>' + esc(C.boton) + '</button>' : '');
  }

  function vigencia() {
    var vig = q('[data-sl-vigencia]'); if (!vig) return;
    var ms = isNaN(fin) ? -1 : fin - Date.now();
    var conPack = PACKS.some(function (k) { return k > 1 && descuento(k) > 0; });
    if (ms <= 0 || !conPack) { vig.hidden = true; return; }
    var d = Math.floor(ms / 864e5), h = Math.floor(ms % 864e5 / 36e5), m = Math.floor(ms % 36e5 / 6e4);
    var cuando = new Date(fin).toLocaleString('es-MX', { timeZone: 'America/Mexico_City', day: 'numeric', month: 'long', hour: '2-digit', minute: '2-digit' });
    vig.hidden = false;
    vig.innerHTML = (es3x2() ? (PACKS.indexOf(2) > -1 ? 'El 2 + 1 gratis y el pack de 2 terminan en ' : 'La oferta 2 + 1 gratis termina en ') : 'Los precios de pack terminan en ') +
      '<b>' + (d > 0 ? d + ' d ' : '') + h + ' h ' + m + ' min</b><span>' + cuando + ' (hora del centro de México)</span>';
  }

  function urgencia() {
    var u = q('[data-sl-urgencia]'), h = '';
    if (CFG.tarjeta > 0 && ofertaActiva() && CFG.tarjetasQuedan !== '' && CFG.tarjetasQuedan != null && Number(CFG.tarjetasQuedan) > 0) {
      var tq = Number(CFG.tarjetasQuedan), packs = TMAX === 2 ? 'packs de 2 kits' : 'packs';
      h += '<div class="sl-alerta"><span>' + (tq >= CFG.tarjetasCupo
        ? 'Tarjeta de regalo de $' + CFG.tarjeta + ' solo para los primeros ' + CFG.tarjetasCupo + ' ' + packs + '.'
        : 'Quedan <b>' + tq + '</b> de ' + CFG.tarjetasCupo + ' tarjetas de regalo de $' + CFG.tarjeta + (TMAX === 2 ? ' con el pack de 2 kits.' : ' — elige 2 o 3 kits.')) + '</span></div>';
    }
    var v = V[estado.estilos[0]];
    if (v.seguimiento && v.cantidad > 0 && v.cantidad <= CFG.umbral) {
      h += '<div class="sl-alerta"><span>Quedan <b>' + v.cantidad + '</b> kits' + (D.tieneEstilos ? ' del estilo ' + v.titulo : '') + '.</span></div>';
    }
    u.hidden = !h; u.innerHTML = h;
  }

  raiz.addEventListener('change', function (e) {
    if (e.target.name === 'sl-pack') { estado.kits = Number(e.target.value); q('[data-sl-aviso]').textContent = ''; pintar(); }
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('button'); if (!b) return;
    if (b.dataset.kit) { estado.estilos[Number(b.dataset.kit)] = Number(b.dataset.est); pintar(); }
    else if (b.hasAttribute('data-sl-ir')) { document.getElementById('sl-compra').scrollIntoView({ behavior: 'smooth' }); }
    else if (b.hasAttribute('data-sl-elegir')) {
      var j = Number(b.getAttribute('data-sl-elegir'));
      if (V[j] && V[j].disponible) estado.estilos[0] = j;
      pintar(); irAPacks();
    }
    else if (b.hasAttribute('data-sl-3x2')) {
      var libres = [];
      V.forEach(function (v, i) { if (v.disponible) libres.push(i); });
      if (libres.length) { estado.kits = 3; estado.estilos = [0, 1, 2].map(function (n) { return libres[n % libres.length]; }); }
      pintar(); irAPacks();
    }
    else if (b.hasAttribute('data-sl-mini')) {
      q('[data-sl-principal]').src = b.getAttribute('data-sl-mini');
      raiz.querySelectorAll('[data-sl-mini]').forEach(function (x) { x.setAttribute('aria-current', String(x === b)); });
    }
    else if (b.hasAttribute('data-sl-cta')) agregar(b);
  });

  function irAPacks() {
    var p = q('[data-sl-packs]') || document.getElementById('sl-compra');
    p.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function agregar(btn) {
    var cant = {}, aviso = q('[data-sl-aviso]');
    elegidas().forEach(function (v) { cant[v.id] = (cant[v.id] || 0) + 1; });
    var items = Object.keys(cant).map(function (id) { return { id: Number(id), quantity: cant[id] }; });
    btn.disabled = true; btn.textContent = 'Agregando…'; aviso.textContent = '';
    fetch(D.addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function () { window.location.href = D.cartUrl; })
      .catch(function () { aviso.textContent = 'No pudimos agregarlo. Inténtalo de nuevo.'; pintar(); });
  }

  (function () {
    var aviso = q('[data-sl-aviso]'), ancla = aviso, g = q('.sl-garantias'), tpl = document.getElementById('sl-pagos-tpl');
    if (!aviso) return;
    if (g) { ancla.after(g); ancla = g; }
    if (tpl && tpl.innerHTML.trim()) {
      var p = document.createElement('div');
      p.className = 'sl-pagos';
      p.innerHTML = '<span>Pago seguro con</span><div>' + tpl.innerHTML + '</div>';
      ancla.after(p); ancla = p;
    }
    var caja = document.createElement('div');
    caja.className = 'sl-of-caja'; caja.setAttribute('data-sl-of-caja', ''); caja.hidden = true;
    ancla.after(caja);
    if (!document.getElementById('sl-of-css')) {
      var st = document.createElement('style'); st.id = 'sl-of-css';
      st.textContent = '.sl .sl-of-caja{display:grid;gap:8px;justify-items:center;text-align:center;background:#FFF4F6;border:2px solid var(--sl-rosa-int);border-radius:18px;padding:20px 16px;margin-top:18px}' +
        '.sl .sl-of-caja[hidden]{display:none!important}' +
        '.sl .sl-of-tag{background:var(--sl-rosa-int);color:#fff;font:700 13px var(--sl-d);letter-spacing:.08em;border-radius:999px;padding:6px 14px}' +
        '.sl .sl-of-tit{font:700 24px/1.2 var(--sl-d);color:var(--sl-rosa-int)}' +
        '.sl .sl-of-txt{margin:0;font-size:17px}.sl .sl-of-txt b{color:var(--sl-rosa-int);font-size:20px}' +
        '.sl .sl-of-sep{background:#FCE3E8;border-radius:12px;padding:8px 16px;font:500 16px var(--sl-d)}.sl .sl-of-sep b{margin-left:4px}' +
        '.sl .sl-of-btn{margin-top:4px;min-height:48px;width:100%;max-width:320px;border:0;border-radius:999px;background:var(--sl-rosa-int);color:#fff;font:700 16px var(--sl-d);cursor:pointer}' +
        '.sl .sl-of-btn:focus-visible{outline:2px solid var(--sl-negro);outline-offset:3px}';
      document.head.appendChild(st);
    }
    var vig = q('[data-sl-vigencia]'); if (vig) vig.className = 'sl-vigencia';
  })();

  var sticky = q('[data-sl-sticky]'), ctaEl = q('[data-sl-cta]');
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (en) { sticky.hidden = en[0].isIntersecting || en[0].boundingClientRect.top > 0; }).observe(ctaEl);
  }
  pintar();
  if (!isNaN(fin)) setInterval(function () { if (fin - Date.now() < 0 && fin - Date.now() > -61000) pintar(); else { vigencia(); urgencia(); cajaOferta(); } }, 30000);
})();
